import { n as o, F as n, c as s } from "./export-cdcbfb2b.js";
import { a as w } from "./array-slice-79f93c56.js";
var c = {}, m = n, d = s, t = o.f, i = w, a = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], p = function(r) {
  try {
    return t(r);
  } catch {
    return i(a);
  }
};
c.f = function(e) {
  return a && m(e) === "Window" ? p(e) : t(d(e));
};
export {
  c as o
};
